import React from "react";
import { ImageSourceSetData } from "../../../common/classes/ImageSourceSet";
import { parsePrefecture, getDefaultImage } from "../../../utils/GeneralUtils";
import styles from "./ListCard.module.scss";
import SonicLink from "../../../common/routing/SonicLink";

type CardProps = {
  id: string;
  name: string;
  img?: ImageSourceSetData;
  prefecture?: string;
  onClick?: () => void;
  // title?: string;
  // body?: string;
};

const ListCard: React.FC<CardProps> = ({
  id,
  name,
  img,
  prefecture,
  onClick,
  // title,
  // body,
}) => (
  <li className={styles["f-listCard"]}>
    <SonicLink
      to={`/facility/${id}`}
      className={styles["f-listCard__link"]}
      onClick={onClick}
    >
      <div className={styles["f-listCard__link-img-wrap"]}>
        <div className={styles["f-listCard__link-img"]}>
          {prefecture && (
            <span className={styles["f-listCard__link-img__prefecture"]}>
              {parsePrefecture(prefecture).toLocaleUpperCase()}
            </span>
          )}
          <img src={img ? img.large.url : getDefaultImage()} alt={name} />
          <p className={styles["f-listCard__link-img__name"]}>{name}</p>
        </div>
      </div>
      {/* TODO トピックスに施設の情報を追加する際に調整 */}
      {/* {title && <div>{title}</div>}
      {body && <p>{body}</p>} */}
    </SonicLink>
  </li>
);

export default ListCard;
